import {useEffect, useState} from "react";
import {getMeasurementsByUser} from "../api/getMeasurementsByUser";
import {MEASUREMENT_VISUALIZATION_MODAL_CONTENT} from "../components/MeasurementVisualizationModalContent";
import {deleteMeasurement} from "../../../services/measurement";

export const useMeasurementVisualization = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [measurements, setMeasurements] = useState([]);
  const [deletingMeasurementId, setDeletingMeasurementId] = useState<string>('');
  const [modalContent, setModalContent] = useState<MEASUREMENT_VISUALIZATION_MODAL_CONTENT | ''>('');

  const fetch = async () => {
    setLoading(true);
    try {
      const lineToken = localStorage.getItem("lineToken");
      if (lineToken) {
        const tempMeasurements = await getMeasurementsByUser(lineToken);
        setMeasurements(tempMeasurements);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onRequestDeleteMeasurement = (measurementId) => {
    setDeletingMeasurementId(measurementId);
    setModalContent(MEASUREMENT_VISUALIZATION_MODAL_CONTENT.CONFIRM_DELETE);
  }
  const onConfirmDeleteMeasurement = async () => {
    setModalContent(MEASUREMENT_VISUALIZATION_MODAL_CONTENT.LOADING);
    try {
      const lineToken = localStorage.getItem("lineToken");
      if (lineToken) {
        await deleteMeasurement({token: lineToken, id: deletingMeasurementId})
      }
      setModalContent(MEASUREMENT_VISUALIZATION_MODAL_CONTENT.DELETED);
      await fetch();
    } catch (error) {
      console.error(error);
      setModalContent('');
    }
  }

  const onConfirmSuccess = () => setModalContent('');

  useEffect(() => {
    fetch();
  }, []);

  return {
    loading,
    measurements,
    modalContent,
    onRequestDeleteMeasurement,
    onConfirmDeleteMeasurement,
    onConfirmSuccess
  }
}